$(document).on('keydown', '[onenter]', function(event){
  if(event.which === 13) {
    event.preventDefault();
    eval(event.currentTarget.getAttribute('onenter'));
  }
})
